import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost"
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import IExchangeVoucher from "./IExchangeVoucher";
import { autos } from "../../../../../Context/Local";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { accountsURL } from '../../../../../api/IExchange';
import { Dialog } from "@material-ui/core";
import dataF from "../../../../../Server/dataF.json"

function getReFormatingAccount(data){

    const newData = data.map((row, i)=> {
            return {id: row.id,
                 name:row.symbol,
                 code: row.barcode,
                } 
        })
    return newData
}

export default function IExchangeVoucherDialog(props){

    const {open, onClose,onSave ,invData } = props;
    const [branch, setBranch] = useState({ id: -1, name: "الكل" });
    const tb = {
      wait: true,
      Branch: true,
      stor: { ...sto, branchi:branch.id == -1 ? invData.branch : branch.id },
      parms: { 
          branch: branch.id == -1 ? invData.branch : branch.id  ,
          iempid: sto.empi,
       },
  
    };
  
    const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
      uri + "GetD",
      tb,
      [branch]
    );
     const requestData ={
      wait: true,
      other: true,
      Users: true,
      Stocks: true, // Error // out
      Banks: true,
      CustomersWTypes: true,
      AccountBooks: true,
      costcenters: true,
      Employees: true,
      CheckStatus: true,
      PermissionsElemnts: true,
      parms:{
        ibranchid:branch.id == -1 ? invData.branch : branch.id , 
        iempid: sto.empi,
        iuserid: sto.idi, 
        icustmtype: 1,
        scurrenciestype: 'I',
        branch: branch.id == -1 ? invData.branch : branch.id ,
        tname: "sandsd",
        iformid: dataF[69].id,
      },
      autos:{
        AccountBooks: true,
        Users:true,
        Safes:true,
        Stocks:true,
        Banks:true,
        Employees:true,
        costcenters: true,
        CheckStatus: true,
      }
    }
  
    const url = uri+'Res';

    const {object:AutoOptions, fetching: fetchinData, fetch:fetchURL} = 
     useFetchObjectByPost(url, requestData,[branch]);
    const {data, fetching, fetchURL: fetchURL1} = useFetchURL({...{
      url: accountsURL,
      mapFunction: getReFormatingAccount,
    }})


      if(fetchinData || !data || fetching || !AutoOptions.Stocks ||!AutoOptionsB?.Branches)
        return <BackdropScI />

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
         <IExchangeVoucher
        {...{
            ...props,
            AutoOptions: AutoOptions?.Employees? {...AutoOptions, Customers: data}: [],
            fetchURL,
            prmis: AutoOptions?.permisElm?? insh.permiElm,
            invData,
            isDialog: false,
            isDialogData: true,
            AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
            branch,
            setBranch,
        }}/>
        </Dialog> 

    )
}

   

